import { CommonModule } from "@angular/common";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { AlertPayload } from "src/app/app-data/alert.data";
import { AlertService } from "src/app/services/alert.service";

@Component({
  selector: "app-alerts",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./alerts.component.html",
  styleUrl: "./alerts.component.scss",
})
export class AlertsComponent implements OnInit, OnDestroy {
  alertList: AlertPayload[] = [];
  alertSuccessSubscription!: Subscription;
  alertWarningSubscription!: Subscription;
  alertDangerSubscription!: Subscription;

  constructor(private readonly alertService: AlertService) {}

  ngOnInit(): void {
    this.alertSuccessSubscription =
      this.alertService.showSuccessAlert.subscribe((value) => {
        if (value) {
          this.showSuccessAlert(value);
        }
      });
    this.alertWarningSubscription =
      this.alertService.showWarningAlert.subscribe((value) => {
        if (value) {
          this.showWarningAlert(value);
        }
      });
    this.alertDangerSubscription = this.alertService.showDangerAlert.subscribe(
      (value) => {
        if (value) {
          this.showErrorAlert(value);
        }
      }
    );
  }

  showSuccessAlert(value: AlertPayload) {
    this.alertList.push(value);
    setTimeout(() => {
      this.alertList = this.alertList.filter((t) => t !== value);
      this.alertService.showSuccessAlert.next(null);
    }, 4500);
  }

  showWarningAlert(value: AlertPayload) {
    this.alertList.push(value);
    setTimeout(() => {
      this.alertList = this.alertList.filter((t) => t !== value);
      this.alertService.showWarningAlert.next(null);
    }, 4500);
  }

  showErrorAlert(value: AlertPayload) {
    this.alertList.push(value);
    setTimeout(() => {
      this.alertList = this.alertList.filter((t) => t !== value);
      this.alertService.showDangerAlert.next(null);
    }, 4500);
  }

  closeAlert(value: AlertPayload) {
    this.alertList = this.alertList.filter((t) => t !== value);
    this.alertService.showSuccessAlert.next(null);
    this.alertService.showWarningAlert.next(null);
    this.alertService.showDangerAlert.next(null);
  }

  ngOnDestroy(): void {
    this.alertSuccessSubscription.unsubscribe();
    this.alertWarningSubscription.unsubscribe();
    this.alertDangerSubscription.unsubscribe();
  }
}
